// src/store.js
import heroReducer from './redux/hero.slice';

import { configureStore } from '@reduxjs/toolkit'

export default configureStore({
  reducer: {
    hero: heroReducer
  }
})